import { Pipe, PipeTransform } from '@angular/core';
import { PercentagePipe } from './percentage.pipe';

@Pipe({
  name: 'meanPercentage'
})
export class MeanPercentagePipe implements PipeTransform {
  constructor(private percentagePipe: PercentagePipe) { }

  transform(value: number, total: number, decimals = 0): any {
    const mean = value / total;

    return this.percentagePipe.transform(mean, decimals);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/pipes/mean-percentage.pipe.ts